import { BookOpen, GraduationCap, Shield, FileText } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface KnowledgeCard {
  /** Slug used to look up the card from its article page. */
  id: string;
  /** Link target / route path. */
  path: string;
  icon: LucideIcon;
  title: string;
  description: string;
  /** Background image, shared by the card and the article page hero. */
  image: string;
  imageAlt: string;
}

export const knowledgeCards: KnowledgeCard[] = [
  {
    id: 'what-is-a-fractional-ciso',
    path: '/what-is-a-fractional-ciso',
    icon: BookOpen,
    title: 'What is a Fractional CISO?',
    description:
      'Learn what a fractional CISO is, how they work, and why growing businesses choose this model for cybersecurity leadership.',
    image: '/images/knowledge/what-is-a-fractional-ciso.avif',
    imageAlt: 'Security leader reviewing strategy at a desk',
  },
  {
    id: 'become-a-fractional-ciso',
    path: '/become-a-fractional-ciso',
    icon: GraduationCap,
    title: 'Become a Fractional CISO',
    description:
      'Join our network of experienced security leaders. Discover the benefits of working flexibly with diverse clients.',
    image: '/images/knowledge/become-a-fractional-ciso.avif',
    imageAlt: 'Confident senior security professional',
  },
  {
    id: 'cybersecurity-frameworks',
    path: '/knowledge-hub/cybersecurity-frameworks',
    icon: Shield,
    title: 'Cybersecurity Frameworks Explained',
    description:
      'A plain-English guide to ISO 27001, SOC 2, NIS2, Cyber Essentials, NIST CSF, DORA, PCI DSS and GDPR.',
    image: '/images/knowledge/cybersecurity-frameworks.avif',
    imageAlt: 'Structured compliance frameworks and controls',
  },
  {
    id: 'glossary',
    path: '/knowledge-hub/glossary',
    icon: FileText,
    title: 'CISO Glossary',
    description:
      'A plain-English guide to the terms, acronyms, and concepts every security leader and board member should know.',
    image: '/images/knowledge/glossary.avif',
    imageAlt: 'Open reference book of definitions',
  },
];

export const getKnowledgeCard = (id: string): KnowledgeCard | undefined =>
  knowledgeCards.find(card => card.id === id);
